export const STICKY_NOTES_API_ROUTE = 'sticky-notes';

export const STICKY_NOTE_API_ROUTE = 'sticky-note';

export const STICKY_NOTES_URL = `${process.env.REACT_APP_STICKY_NOTES_API_BASE_URL}`;
